function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Table_lamp_2"
}, /*#__PURE__*/React.createElement("title", null, "VF_table_lamp_2_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M198.9 127.7l84.6.2L219.5 0H64L0 127.3l84.8.2c-1.3 2.8-2.6 5.7-3.9 8.9-11.2 28.4-16.8 67.9-16.8 117.1v30h155.5v-30c0-49.2-5.7-88.6-16.9-117.1-1.3-3.1-2.5-6-3.8-8.7zM81.4 28.4H202l35.6 71-191.7-.3 35.5-70.7zm109.8 226.8H92.4v-1.7c0-60.3 9.2-104.7 25.1-125.9l48.6.1c15.9 21.3 25.1 65.7 25.1 125.9v1.6z"
}))));